import React, { useState, useMemo } from 'react'
import { Switch, Route } from 'react-router-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import Drawer from '@material-ui/core/Drawer'
import Container from '@material-ui/core/Container'
import MainMenu from '../MainMenu'
import DashboardPage from '../DashboardPage'
import ProgressPage from '../ProgressPage'
import ManagementPage from '../ManagementPage'
import StoriesOverview from '../StoriesOverview'
import StoryReview from '../StoryReview'
import Engagement from '../Engagement'
import EventsPage from '../EventsPage'
import AccountSettingsPage from '../AccountSettingsPage'
import ForgotPasswordPage from '../ForgotPasswordPage'
import AccountSetupPage from '../AccountSetupPage'
import LoginPage from '../LoginPage'
import LogoutPage from '../LogoutPage'
import PrivateRoute from './PrivateRoute'

import { LINKS } from '../../constants'
import { useStyles } from './styles'

import { LabContext } from '../../context'

const ApplicationLayout = () => {
  const classes = useStyles()
  const [selectedLab, setSelectedLab] = useState('')
  const [labs, setLabs] = useState([])
  const [selectedAccount, setSelectedAccount] = useState('')
  const [accounts, setAccounts] = useState([])
  const [isSuperCoordinator, setIsSuperCoordinator] = useState(false)

  const contextValue = useMemo(
    () => ({
      selectedLab,
      setSelectedLab,
      labs,
      setLabs,
      accounts,
      setAccounts,
      selectedAccount,
      setSelectedAccount,
      isSuperCoordinator,
      setIsSuperCoordinator
    }),
    [selectedLab, labs, selectedAccount, accounts, isSuperCoordinator]
  )

  return (
    <div className={classes.layoutContainer}>
      <Switch>
        <Route exact={true} path={LINKS.LOGIN} component={LoginPage} />
        <Route exact={true} path={LINKS.LOGOUT} component={LogoutPage} />
        <Route exact={true} path={LINKS.FORGOT_PASSWORD} component={ForgotPasswordPage} />
        <Route exact={true} path={LINKS.ACCOUNT_SETUP} component={AccountSetupPage} />
        <>
          <LabContext.Provider value={contextValue}>
            <div className={classes.root}>
              <CssBaseline />
              <Drawer
                variant='permanent'
                classes={{
                  paper: classes.drawerPaper
                }}
              >
                <MainMenu />
              </Drawer>
              <main className={classes.content}>
                <Container maxWidth={false} className={classes.container} disableGutters>
                  <PrivateRoute exact={true} path={LINKS.DASHBOARD} component={DashboardPage} />
                  <PrivateRoute exact={true} path={LINKS.PROGRESS} component={ProgressPage} />
                  <PrivateRoute exact={true} path={LINKS.MANAGEMENT} component={ManagementPage} />
                  <PrivateRoute exact={true} path={LINKS.STORIES_OVERVIEW} component={StoriesOverview} />
                  <PrivateRoute exact={true} path={LINKS.STORY_REVIEW} component={StoryReview} />
                  <PrivateRoute exact={true} path={LINKS.ENGAGEMENT} component={Engagement} />
                  <PrivateRoute exact={true} path={LINKS.ACCOUNT_SETTINGS} component={AccountSettingsPage} />
                  <PrivateRoute exact={true} path={LINKS.EVENTS} component={EventsPage} />
                </Container>
              </main>
            </div>
          </LabContext.Provider>
        </>
      </Switch>
    </div>
  )
}

export default ApplicationLayout
